export const MY_REFERRALS_PATH = '/my-referrals';
export const COMMISSIONS_PATH = '/commissions';
export const MY_WALLET_PATH = '/my-wallet';
export const ACCOUNT_PATH = '/account';
